import React from "react";
import { PropTypes } from "prop-types";
import { MrbModal } from "mrb/components/modal";
import { defaultTemplate } from "common/hoc";

function UserHideTrendingInfoModalTemplate({ modalParams, t }) {
    return (
        <MrbModal
            className="modal__content modal__content--xlrg"
            modalParams={modalParams}
            shouldCloseOnOverlayClick={true}
            displayCloseIcon={true}
        >
            <div className="u-type--base u-mar--top--sml">
                <p className="u-mar--bottom--sml">
                    {t("APPLICATION.USER_SETTINGS.EDIT.FIELDS.HIDE_TRENDING.INFO_MODAL.DESCRIPTION")}
                </p>
            </div>
        </MrbModal>
    );
}

UserHideTrendingInfoModalTemplate.propTypes = {
    modalParams: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
};

export default defaultTemplate(UserHideTrendingInfoModalTemplate);
